import React from 'react';
import ResultPanel from '../components/result-panel/result-panel';
import {View, StyleSheet} from 'react-native';
import globalStore from '@/services/global.state';
import Text from '@/components/basic/text';
import Ball from '@/common-pages/color/components/ball';
import theme from '@/style';
import {useTranslation} from 'react-i18next';
import {ALL_BALLS} from '@/common-pages/color/constant';
import dayjs from 'dayjs';
import {formatDate, goTo} from '@/utils';
import {getColor} from '@/common-pages/bets/bets.service';
import {BasicObject} from '@/types';

const ColorDraw = () => {
  const [colorOrder, setColorOrder] = React.useState<BasicObject>();
  const {t} = useTranslation();

  const getResult = async () => {
    try {
      const res = await getColor({
        pageNo: 1,
        pageSize: 1,
        orderStatus: '4',
        yearMonth: formatDate(new Date(), 'yyyyMM'),
      });
      if (res.content) {
        setColorOrder(res.content[0]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    if (globalStore.token) {
      getResult();
    }
  }, []);

  return colorOrder?.issueNo ? (
    <ResultPanel
      winAmount={colorOrder.awardAmount}
      containerStyle={styles.panelContainer}
      betInfo={
        <Text size="medium" fontFamily="fontInterBold" main numberOfLines={2}>
          {colorOrder.gameName}
        </Text>
      }
      onMore={() => goTo('Bets', {tag: 'Color'})}
      betTime={dayjs(colorOrder.createTime).format('DD-MM-YYYY hh:mm A')}>
      <View style={styles.contentWrap}>
        <View style={[theme.flex.center, styles.leftCol, styles.leftColAnna]}>
          <Text accent size="small" style={styles.sectionTitle}>
            {t('home.tab.result')}
          </Text>
          <View style={styles.resultBallWrap}>
            <Ball
              digit={colorOrder!.digitResult}
              ballSize={20}
              color={colorOrder.colorResult}
              fontSize={10}
              onlyColor={false}
            />
          </View>
        </View>
        <View style={[theme.flex.center, styles.rightCol]}>
          <Text accent size="small" style={styles.sectionTitle}>
            {t('game-page.label.myBets')}
          </Text>
          <View
            style={[
              theme.flex.row,
              theme.flex.wrap,
              theme.flex.center,
              styles.betList,
            ]}>
            {colorOrder.subsetList
              .filter((item: BasicObject) =>
                colorOrder.awardAmount > 0 ? item.awardAmount > 0 : true,
              )
              .map((item: BasicObject, _i: number) => (
                <Ball
                  key={_i}
                  digit={item.selectValue}
                  ballSize={20}
                  fontColor="#fff"
                  color={
                    item.selectType === 2
                      ? item.selectValue
                      : ALL_BALLS.find(pie => pie.digit === item.selectValue)
                          ?.color
                  }
                  fontSize={10}
                  onlyColor={item.selectType === 2}
                />
              ))}
          </View>
        </View>
      </View>
    </ResultPanel>
  ) : (
    <View />
  );
};

const styles = StyleSheet.create({
  panelContainer: {
    marginTop: 12,
    marginBottom: 4,
    marginHorizontal: 12,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: '500',
    opacity: 0.7,
  },
  contentWrap: {
    flexDirection: 'row',
    width: '100%',
    paddingTop: 8,
    paddingBottom: 6,
  },
  leftCol: {
    flex: 1,
    gap: 2,
  },
  leftColAnna: {
    borderRightWidth: 1,
    borderRightColor: '#D8E0EA',
  },
  rightCol: {
    flex: 1,
    gap: 2,
  },
  resultBallWrap: {
    padding: 8,
  },
  betList: {
    gap: theme.paddingSize.s,
    maxWidth: 200,
    padding: 8,
    justifyContent: 'center',
  },
});

export default ColorDraw;
